<template>
  <div class="header">
    <div class="header-body">
      <div class="header-body-title">{{info.title}}</div>
      <div class="header-body-line"></div>
      <div class="header-body-desc">{{info.desc}}</div>
    </div>
    <img :src="info.banner" class="bg">
  </div>
</template>

<script>
export default {
  props: {
    info: Object
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped>
.bg {
  width: 1920px;
  height: 560px;
  position: absolute;
  top: 0;
  right: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 0;
}
.header {
  text-align: center;
  color: #ffffff;
  height: 560px;
  overflow: hidden;
  position: relative;
}
.header-body {
  max-width: 1200px;
  margin: 220px auto 0;
  font-size: 18px;
  position: relative;
  z-index: 1;
}
.header-body-title {
  font-size: 2.2em;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(250,250,250,1);
}
.header-body-line {
  width:40px;
  height:1px;
  background:rgba(255,255,255,1);
  margin: 22px auto 30px;
}
.header-body-desc {
  font-size: 1em;
  color:rgba(255,255,255,1);
  line-height: 1.8em;
}
@media (max-width: 1199px) and (min-width: 992px){
  .header-body {
    padding: 0 100px;
  }
  .header-body {
    font-size: 16px;
  }
}
@media (max-width: 991px) and (min-width: 768px){
  .header-body {
    padding: 0 100px;
  }
  .header-body {
    font-size: 14px;
  }
}
@media screen and (max-width: 767px){
  .header-body {
    padding: 0 100px;
  }
  .header-body {
    font-size: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/solution/detailHeader.vue